namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_method, {
		
		Title_text: {
			lineHeight: '1',
		},

		Title_input: {
			['fieldSizing' as any]: 'content',
		},

		Decorator: {
			margin: {
				left: 'auto',
			},
		},
		
	} )
	
}
